module.exports = __webpack_public_path__ + "img/cause_4.3a937316.svg";